import React from 'react';

import MtgLandingPage from '../../components/MtgLandingPage';
import withDynamicLocale from '../../functions/withDynamicLocale';


function Page() {
    return (
        <MtgLandingPage />
    );
}

Page.getInitialProps = async() => ({
    headerSettings: {
        disableMenu: true,
        isHidden: true,
    },
    footerSettings: {
        isDisabled: true,
        isPopularContentDisabled: true,
    },
});

export default withDynamicLocale(Page);
